export default "__VITE_ASSET__B9BVFYos__"